<footer class="main-footer">
  <!-- <div class="container-dynamic flex">
    <div class="m-auto">Designed & Developed by &nbsp;<a target="_blank" href="https://www.elkanio.com/">ELKANIO</a></div>
  </div> -->
</footer>